// eslint-disable-next-line no-restricted-imports
import type { UseFormReturn } from 'react-hook-form';

import { getFirstErrorFieldName } from './getFirstErrorFieldName';

interface ScrollOptions {
    autoScrollToError: boolean;
    autoFocusOnError: boolean;
}

export const scrollAndFocusFirstError = <FormValue extends Record<string, any>>(
    form: UseFormReturn<FormValue>,
    { autoScrollToError, autoFocusOnError }: ScrollOptions,
): void => {
    const { errors } = form.formState;
    const firstField = getFirstErrorFieldName(errors);

    if (!firstField) return;

    const el = document.querySelector(`[name="${firstField}"]`) as HTMLElement | null;

    if (autoScrollToError && el) {
        el.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
    }

    if (autoFocusOnError && el) {
        el.focus({ preventScroll: true });
    }
};
